import { render, staticRenderFns } from "./paySettingItem.vue?vue&type=template&id=05ee0398&scoped=true&"
import script from "./paySettingItem.vue?vue&type=script&lang=js&"
export * from "./paySettingItem.vue?vue&type=script&lang=js&"
import style0 from "./paySettingItem.vue?vue&type=style&index=0&id=05ee0398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee0398",
  null
  
)

export default component.exports